export default [
  {
    path: '',
    name: 'home',
    component: () => import('@/views/SecondPage.vue'),
    meta: {
      pageTitle: 'Home',
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
      resource: 'Home',
    },
  },
]
